import { render, staticRenderFns } from "./ActionShareRequest.vue?vue&type=template&id=be9653b0&scoped=true"
import script from "./ActionShareRequest.vue?vue&type=script&lang=js"
export * from "./ActionShareRequest.vue?vue&type=script&lang=js"
import style0 from "./ActionShareRequest.vue?vue&type=style&index=0&id=be9653b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9653b0",
  null
  
)

export default component.exports